import { Tool } from './base';

export class PaloAltoCortexXDRTool extends Tool {
  public readonly toolName = 'Palo Alto Cortex XDR';

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string
  ): string {
    const encodedRenderedContent = encodeURIComponent(renderedContent);
    //https://lexicorplab.xdr.us.paloaltonetworks.com/
    //Set time to Last 30 days
    // const currentDate = new Date();
    // const myPastDate = new Date(currentDate);
    // myPastDate.setDate(myPastDate.getDate() - 30);
    return `${rootURL}/xql/xql-search?phrase=${encodedRenderedContent}&execute_query_parameter=true`;
  }
}
